import { useSession } from './useSession';

export function checkPermission(session, name, groupName) {
  const roleItems = session?.user?.roleGroupItems;

  if (roleItems) {
    const permission = roleItems?.find(item => name?.includes(item.name) && groupName?.includes(item.roleGroupName));
    return !!permission;
  }
  return false;
}

export default function usePermission(name, groupName) {
  const { session } = useSession();
  return checkPermission(session, name, groupName);
}
